module.exports = ".page-header {\n  bottom: 0; }\n"